<script>
import moment from 'moment';
import API from '../services/api';

const api = new API();

module.exports = {
  template : '#vouchers-template',
  data     : function() {
    return {};
  },
  computed : {
    vouchers : function() {
      let vouchers = this.$store.state.vouchers ? this.$store.state.vouchers : [];

      vouchers = vouchers.reduce((result, item) => {
        if (item.value == 0) item.value = false;

        if (item.used == '') result.push(item);

        return result;
      }, []);

      return {
        loading : this.$store.state.vouchers ? false : true,
        items   : vouchers
      };
    }
  }
};
</script>